import React from 'react';

import Markdown from 'markdown-to-jsx';
import PropTypes from 'prop-types';

import { useIntl } from '~/techstyle-shared/react-intl';

export const BuilderLocalizedRichText = ({ text }) => {
  const { locale } = useIntl();

  if (typeof text === 'string') {
    return <Markdown>{text}</Markdown>;
  } else {
    // Although RichText on Builder looks empty, it always returns <p><br><p> tags.
    if (text[locale] && !text[locale].replace(/(<([^>]+)>)/gi, '')) {
      return <Markdown>{text.Default}</Markdown>;
    } else if (text[locale] || text.Default) {
      return <Markdown>{text[locale] || text.Default}</Markdown>;
    }
    return null;
  }
};

export const richTextIsEmpty = (text) => {
  // <p><br></p> appears to be the default value if someone interacts with the editor and then removes everything
  return !text || !text.length || text === '<p><br></p>';
};

BuilderLocalizedRichText.propTypes = {
  text: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};

export default BuilderLocalizedRichText;
